import * as React from "react";
import {
    ClientInquiryMethod,
    ClientStatus,
    IClient,
    IClientBooking,
    InsuranceType,
    InsuranceYesOrNo,
    RelationshipToPrimaryInsured,
    UserSex,
} from "intake_shared/src/types";
import CompleteClientFlow, {
    CASELOAD_CANCELLATION_REASONS,
} from "../client-forms/CompleteClientFlow/CompleteClientFlow";

interface IClientDisplayDialogOptions {
    expectedCaller: "clinician" | "admin";
    show: boolean;
    allowEdit: boolean;
    allowChangeStatus: boolean;
    client: IClient;
    onHide: () => void;
    onSaveClient: (client: IClient) => Promise<void>;
    bookingId: string;
}

export const defaultClient: IClient = {
    id: "ec96ff60-86bc",
    email: "",
    phone_no: "",
    first_name: "",
    preferred_name: "",
    last_name: "",
    pronouns: "",
    address: "",
    date_of_birth: null,
    zip_code: "",
    city: "",
    client_is_b2b: false,
    client_is_on_trial: false,
    primary_insured_state: "",
    primary_insured_city: "",
    primary_insured_zipcode: "",
    insurance_provider: "",
    insurance_member_id: "",
    insurance_plan_employer: "",
    intake_session_history: [],
    group_number: "",
    notes: "",
    requested_time: "",
    requested_day: "",
    client_services_notes: "",
    accept_assignment: "N" as InsuranceYesOrNo,
    sex: "M" as UserSex,
    status: ClientStatus.INCOMPLETE_INQUIRY,
    held_bookings: [] as IClientBooking[],
    confirmed_bookings: [] as IClientBooking[],
    waitlist_clinician_ids: [],
    waitlist_locations: [],
    waitlist_time_categories: [],
    waitlist_days: [],
    waitlist_wants_intern: false,
    complete_notes: {
        reason: "",
    },
    inquiry_method: "" as ClientInquiryMethod,
    status_history: {
        "Incomplete Inquiry": new Date(),
    },
    requested_service: "",
    requested_therapist: [],
    on_waitlist: false,
    referred_by: "",
    insurance_type: InsuranceType.GROUP_HEALTH_PLAN,
    relationship_to_primary_insured: RelationshipToPrimaryInsured.SELF,
    appointment_history: [],
    is_blacklisted: false,
    applicable_fee: {},
    webform_status: "",
    source: "Humantold",
    inquiry_id: "",
    mode_of_communication: "",
    treatment_type: "",
    preferred_therapist_gender: [],
    presenting_concerns: [],
    consent_to_email: "",
    requested_location: [],
    preferred_language_of_communication: [],
};

interface ClientDisplayDialogProps {
    clientDialogOptions: IClientDisplayDialogOptions;
}

export default function ClientDisplayDialog({
    clientDialogOptions,
}: ClientDisplayDialogProps) {
    const appointmentToCancel = clientDialogOptions.client.confirmed_bookings.find(
        (b) => b.id === clientDialogOptions.bookingId
    );

    if (!clientDialogOptions.show || !clientDialogOptions.client) {
        return null;
    }

    return (
        <CompleteClientFlow
            title="Cancel sessions (Permanently delete from my caseload)"
            clientProp={{
                ...clientDialogOptions.client,
                complete_notes: {
                    ...clientDialogOptions?.client?.complete_notes,
                    notes: "",
                },
            }}
            reasons={CASELOAD_CANCELLATION_REASONS}
            onSaveClient={clientDialogOptions.onSaveClient}
            showCompletionReason
            showCompletionNotes
            showWaitListOption={false}
            showAppointmentsToCancel={true}
            appointmentToCancel={appointmentToCancel}
            expectedCaller={clientDialogOptions.expectedCaller}
            completeBtnText="Cancel Sessions"
            hideCard={true}
            onContinue={clientDialogOptions.onHide}
        />
    );
}
